import { createClient } from '@supabase/supabase-js'

// Project ID will be auto-injected during deployment
const SUPABASE_URL = 'https://krqygjqnwsubalscqqux.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImtycXlnanFud3N1YmFsc2NxcXV4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzEyMzc0MzIsImV4cCI6MjA4NjgxMzQzMn0.1g19ZkYfibj7-qSd6FK_yoKPemjbRXEh5GV4N4Jsjfw'

if(!SUPABASE_URL || !SUPABASE_ANON_KEY ){
    throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})